import { Action } from "./action";
import { ActionDescriptor } from "./action_descriptor";
import { Multimap } from "@stimulus/multimap";
import { TokenListObserver } from "@stimulus/mutation-observers";

var InlineActionObserver =
/** @class */
function () {
  function InlineActionObserver(context, delegate) {
    this.context = context;
    this.delegate = delegate;
    this.tokenListObserver = new TokenListObserver(this.element, this.attributeName, this);
    this.connectedActions = new Multimap();
  }

  Object.defineProperty(InlineActionObserver.prototype, "scope", {
    get: function get() {
      return this.context.scope;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(InlineActionObserver.prototype, "configuration", {
    get: function get() {
      return this.scope.configuration;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(InlineActionObserver.prototype, "attributeName", {
    get: function get() {
      return this.configuration.actionAttribute;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(InlineActionObserver.prototype, "element", {
    get: function get() {
      return this.scope.element;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(InlineActionObserver.prototype, "identifier", {
    get: function get() {
      return this.scope.identifier;
    },
    enumerable: true,
    configurable: true
  });

  InlineActionObserver.prototype.start = function () {
    this.tokenListObserver.start();
  };

  InlineActionObserver.prototype.stop = function () {
    this.tokenListObserver.stop();
  }; // Token list observer delegate


  InlineActionObserver.prototype.elementMatchedTokenForAttribute = function (element, token, attributeName) {
    if (this.scope.containsElement(element)) {
      var action = this.buildActionForElementWithDescriptorString(element, token);

      if (action) {
        this.connectedActions.add(element, action);
        this.delegate.inlineActionConnected(action);
      }
    }
  };

  InlineActionObserver.prototype.elementUnmatchedTokenForAttribute = function (element, token, attributeName) {
    var action = this.getConnectedActionForElementWithDescriptorString(element, token);

    if (action) {
      this.connectedActions.delete(element, action);
      this.delegate.inlineActionDisconnected(action);
    }
  };

  InlineActionObserver.prototype.getConnectedActionForElementWithDescriptorString = function (element, descriptorString) {
    var newAction = this.buildActionForElementWithDescriptorString(element, descriptorString);

    if (newAction) {
      var actions = this.connectedActions.getValuesForKey(element);
      return actions.find(function (action) {
        return action.hasSameDescriptorAs(newAction);
      });
    }
  };

  InlineActionObserver.prototype.buildActionForElementWithDescriptorString = function (element, descriptorString) {
    try {
      var descriptor = ActionDescriptor.forElementWithInlineDescriptorString(element, descriptorString);

      if (descriptor.identifier == this.identifier) {
        return new Action(this.context, descriptor, descriptor.eventTarget);
      }
    } catch (error) {
      this.context.reportError(error, "parsing descriptor string \"" + descriptorString + "\" for element", element);
    }
  };

  return InlineActionObserver;
}();

export { InlineActionObserver };